import { render, staticRenderFns, recyclableRender, components } from "./chart_details.vue?vue&type=template&id=cd93c66c&scoped=true&"
var renderjs
import script from "./chart_details.vue?vue&type=script&lang=js&"
export * from "./chart_details.vue?vue&type=script&lang=js&"
import style0 from "./chart_details.vue?vue&type=style&index=0&id=cd93c66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd93c66c",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/chart_details/chart_details.vue"
export default component.exports